import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconToque: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"toque, chefs-cap, cook"} maskId="square-filled-radius-0-stroke-1-IconToque"><path d="M17.0045 4.88853L17.0692 5.00047C19.7987 5.0375 22 7.26168 22 10C22 12.0503 20.7659 13.8124 19 14.584V17H5V14.584C3.2341 13.8124 2 12.0503 2 10C2 7.2612 4.20205 5.03671 6.93224 5.00045C7.9144 3.21213 9.81562 2 11.9999 2C14.1392 2 16.0062 3.16285 17.0045 4.88853Z" fill="currentColor"/><path d="M5 18V22H19V18H5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconToque;
